export default {

    /**
     * Задает состояние плеера.
     *
     * loading - трек загружается;
     * pause - трек в паузе;
     * playing - трек проигрывается;
     * off - плеер выключен;
     *
     * @param {Object} state
     * @param {String} newState
     */
    SET_PLAYER_STATE(state, newState) {
        state.state = newState;
    },

    /**
     * Установить новый трек
     *
     * @param {Object} state - Vuex.state
     * @param {Object} payload
     * @param {String} payload.id - id лида
     * @param {String} payload.record - Новый путь к треку
     */
    SET_RECORD(state, { id, record }) {
        state.id = id;
        state.record = record;
    },

    /**
     * Открыть/Закрыть плеер
     *
     * @param {Object} state - Vuex.state
     * @param {Boolean} bool - Открыть или закрыть
     */
    TOGGLE(state, bool) {
        state.isShow = bool;

        if (bool) return;

        state.id = '';
        state.record = '';
        state.state = 'off';
    },
};
